import React from "react";
import "./UploadStatusTable.styles.scss";

import LoadingCard from "./loadingCard";
import useSWR from "swr";
//import moment from "moment"
import { format } from "date-fns";

const UploadStatusTable = ({ categorization }) => {
  const upload_status_api_url = `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-list?limit=20`;
  const { data: upload_status_data } = useSWR(upload_status_api_url);

  const filterUploader = (file) => {
    if (!categorization) return true;
    if (file.file_tag === "Merchant-KYC Update") return true;
    return false;
  };

  return (
    <div className="card-col col s12 l12">
      {!upload_status_data ? (
        <LoadingCard />
      ) : (
        <div className="card upload-status">
          <div className="card-title">Status of uploaded files</div>
          <div className="card-body">
            <table>
              <thead>
                <tr>
                  <th>Upload File</th>
                  <th>Upload File Type</th>
                  <th>Start time</th>
                  <th>End time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {upload_status_data.data
                  .filter(filterUploader)
                  .map((data, index) => {
                    return (
                      <Row
                        key={index}
                        fileName={data.file_name}
                        fileTag={data.file_tag}
                        startTime={data.zone_aware_start_time}
                        endTime={data.zone_aware_end_time}
                        status={data.status}
                        isCompleted={data.is_completed}
                      />
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const Row = ({
  fileName,
  fileTag,
  startTime,
  endTime,
  status,
  isCompleted,
}) => {
  return (
    <tr>
      <td>{fileName}</td>
      <td>{fileTag}</td>
      <td>
        {/* {moment(startTime).format("MMMM Do yyyy, h:mm:ss a")} */}
        {format(new Date(startTime), "h:mm a, MMM dd-yyyy")}
      </td>
      <td>
        {endTime === null
          ? "-"
          : // : moment(endTime).format("MMMM Do yyyy, h:mm:ss a")}
            format(new Date(endTime), "h:mm a, MMM dd-yyyy")}
      </td>
      <td>
        <span className={`status ${status}`}>{status}</span>
      </td>
    </tr>
  );
};

export default UploadStatusTable;
